import React from "react";
import { ChevronDown } from "lucide-react";

function SectionHeader({ title, description, expanded }) {
  return (
    <div className="flex items-center justify-between gap-4">
      <div>
        <div className="text-base font-semibold text-green-800 dark:text-green-200">{title}</div>
        {description ? <div className="text-xs text-gray-500 dark:text-gray-400">{description}</div> : null}
      </div>
      <ChevronDown
        size={18}
        className={`text-gray-500 transition-transform ${expanded ? "rotate-180" : "rotate-0"}`}
        aria-hidden="true"
      />
    </div>
  );
}

export default function SettingsAccordion({ sections, defaultOpenId }) {
  const [openId, setOpenId] = React.useState(defaultOpenId ?? sections?.[0]?.id);

  const toggle = (id) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <div className="space-y-4 w-full">
      {sections.map((section) => {
        const expanded = openId === section.id;
        return (
          <div key={section.id} className="bg-white dark:bg-gray-800 rounded-xl shadow overflow-hidden">
            <button
              type="button"
              onClick={() => toggle(section.id)}
              className="w-full text-left p-5 hover:bg-gray-50 dark:hover:bg-gray-700/40 transition"
              aria-expanded={expanded}
              aria-controls={`settings-section-${section.id}`}
            >
              <SectionHeader title={section.title} description={section.description} expanded={expanded} />
            </button>

            {expanded ? (
              <div id={`settings-section-${section.id}`} className="border-t border-gray-100 dark:border-gray-700 p-5">
                {section.content}
              </div>
            ) : null}
          </div>
        );
      })}
    </div>
  );
}
